import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

interface IGPSOnIcon extends SvgIconProps {
  iconColor?: string;
}

function GPSOnIcon({ iconColor = "#FFFFFF", ...props }: IGPSOnIcon) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="GPSOnIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="24px" height="24px" viewBox="0 0 24 24"
      style={{
        //@ts-ignore
        enableBackground: "new 0 0 24 24"
      }} xmlSpace="preserve">
      <path fill={iconColor} d="M10.995,23v-2.009c-2.093-0.234-3.889-1.101-5.387-2.599c-1.499-1.498-2.365-3.294-2.599-5.387H1v-2.009
	h2.009C3.243,8.902,4.11,7.107,5.609,5.608c1.498-1.498,3.294-2.364,5.387-2.599V1h2.009v2.009
	c2.093,0.235,3.888,1.101,5.387,2.599c1.498,1.499,2.365,3.294,2.599,5.387H23v2.009h-2.009c-0.235,2.093-1.101,3.889-2.599,5.387
	c-1.498,1.498-3.294,2.365-5.387,2.599V23H10.995z M12,19.032c1.942,0,3.599-0.687,4.973-2.059c1.373-1.373,2.059-3.03,2.059-4.973
	c0-1.942-0.687-3.599-2.059-4.973C15.6,5.655,13.942,4.968,12,4.968c-1.943,0-3.6,0.687-4.973,2.059
	C5.654,8.4,4.968,10.058,4.968,12c0,1.943,0.686,3.6,2.059,4.973C8.4,18.345,10.058,19.032,12,19.032z M12,16.018
	c-1.105,0-2.051-0.393-2.838-1.181c-0.787-0.787-1.18-1.733-1.18-2.838c0-1.105,0.393-2.051,1.18-2.838
	c0.787-0.787,1.733-1.18,2.838-1.18c1.105,0,2.051,0.394,2.838,1.18c0.787,0.787,1.18,1.733,1.18,2.838
	c0,1.105-0.394,2.051-1.18,2.838C14.051,15.625,13.105,16.018,12,16.018z"/>
    </svg>
  </SvgIcon>
}

export default GPSOnIcon;
